import { render } from "./Services.vue?vue&type=template&id=600fba6d&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-600fba6d"

export default script